import React, { useCallback, useEffect, useRef, useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Button, Collapse, message as alertMessage, Modal, Slider, Switch, Table, message } from "antd";
import {
    verifyToken,
    connectSocket,
    subscribeToChannel,
    startGame,
    revealBlock,
    claimGame,
    getAllBets,
    calculateWinBlocks,
} from '../../components/socket';
import CountUp from 'react-countup';
import moment from "moment";
import ProviderCredit from '../../components/ProviderCredit';
const { Panel } = Collapse;

const audioFiles = {
    amount: "/assets/audio/amount.61415b97.mp3",
    arrows: "/assets/audio/arrows.e5522174.mp3",
    bomb: "/assets/audio/bomb.777c9d64.mp3",
    buttons: "/assets/audio/buttons.a48a7a1a.mp3",
    cashout: "/assets/audio/cashout.37dec33e.mp3",
    dimond1: "/assets/audio/diamond1.8eb9ae26.mp3",
    dimond2: "/assets/audio/diamond2.35890b55.mp3",
    dimond3: "/assets/audio/diamond3.68da1013.mp3",
    difficulty: "/assets/audio/difficulty.ec7c41a2.mp3",
    roll: "/assets/audio/roll.f8451d78.mp3",
    tile: "/assets/audio/tile_click.35cede30.mp3",
    win: "/assets/audio/win.f0b22e3a.mp3",
  };



const isValidWalletBalance = value => (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value));

export default function Mines() {
    const [betMode, setBetMode] = useState("manual");
    const [gameLimits, setGameLimits] = useState(null);
    const [numberOfRounds, setNumberOfRounds] = useState(5);
    const [whenWinningtt, setWhenWinningtt] = useState('increase')
    const [whenLosingtt, setWhenLosingtt] = useState('reset')
    const [winningBetAmount, setWinningBetAmount] = useState(5);
    const [losingBetAmount, setLosingBetAmount] = useState(0);
    const [stopAtWin, setStopAtWin] = useState(false)
    const [tableType, setTableType] = useState("all")
    const [betAmount, setBetAmount] = useState(20);
    const [minesCount, setMinesCount] = useState(3)
    const [muteSound, setMuteSound] = useState(false);
    const [settingsModalVisible, setSettingsVisible] = useState(false)
    const [limitModalVisible, setLimitModalVisible] = useState(false);
    const [rulesModalVisible, setRulesModalVisible] = useState(false);
    const [volume, setVolume] = useState(100)
    const [loadingTile, setLoadingTile] = useState(null);
    const [openedTiles, setOpenedTile] = useState([]);
    const [gameStarted, setGameStarted] = useState(false);
    const [tiles, setTiles] = useState(
        Array(25).fill("")
    );
    const params = new URLSearchParams(window.location.search);
    const allParams = {};
    for (const [key, value] of params?.entries()) {
        allParams[key] = value;
    }




    const [userToken, setUserToken] = useState(null);
    const [socket, setSocket] = useState(null);
    const [userBalance, setUserBalance] = useState(0);
    const [userDetails, setUserDetails] = useState(true);
    const [currencySymbol, setCurrencySymbol] = useState("INR");
    const [siteLoading, setSiteLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [allBetData, setAllBetData] = useState([]);
    const [topBetData, setTopBetData] = useState([]);
    const [myBetData, setMyBetData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [sessionId, setSessionId] = useState(null);

    const [socketConnection, setSocketConnection] = useState(false);
    const [winningModal, setwinningModal] = useState(false);
    const [multiplier, setmultiplier] = useState([]);
    const [autoPlayStart, setAutoplayStart] = useState(false);
    const [autoplayCounter, setautoPlayCounter] = useState(0);
    const [startButtonLoading, setStartButtonLoading] = useState(false);
    const startPendingRef = useRef(false);
    const startTimerRef = useRef(null);
    const resetStartRequest = () => {
        clearTimeout(startTimerRef.current);
        startPendingRef.current = false;
        setStartButtonLoading(false);
    };
    useEffect(() => () => clearTimeout(startTimerRef.current), []);
    const [claimPending, setClaimPending] = useState(false);
    const claimTimerRef = useRef(null);
    const resetClaimRequest = () => {
        clearTimeout(claimTimerRef.current);
        claimTimerRef.current = null;
        setClaimPending(false);
    };
    useEffect(() => () => clearTimeout(claimTimerRef.current), []);
    const [socketStartGame, setSocketStartGame] = useState(false);
    const [winningAmount, setWinningAmount] = useState(0);
    const [oldNumber, setOldNumber] = useState(0.00);
    const [number, setNumber] = useState(0.00);
    const [Allmultipliers, setAllMultiplier] = useState([]);

    // Simulate an API call that updates the number
    useEffect(() => {
        if (winningAmount > 0 || winningAmount?.length > 0) {
            setNumber(parseFloat(winningAmount).toFixed(2))
            setTimeout(() => {
                setOldNumber(parseFloat(winningAmount).toFixed(2))
            }, 1000);
        } else {
            setNumber(0.00)
            setOldNumber(0.00)
        }
    }, [winningAmount]);

    const betModeRef = useRef(betMode);
    const socketRef = useRef(socket);
    const recoveryRef = useRef(null);
    const socketConnectionRef = useRef(socketConnection);
    const gameStartedRef = useRef(gameStarted);
    const stopAtWinRef = useRef(stopAtWin);
    const betAmountRef = useRef(betAmount);
    const winningBetAmountRef = useRef(winningBetAmount);
    const autoPlayStartRef = useRef(autoPlayStart);
    const minesCountRef = useRef(minesCount);
    const numberOfRoundsRef = useRef(numberOfRounds);
    const autoplayCounterRef = useRef(autoplayCounter);
    const losingBetAmountRef = useRef(losingBetAmount);
    const userDetailsRef = useRef(userDetails);
    const sessionIdRef = useRef(sessionId);
    const muteSoundRef = useRef(muteSound);
    const tableTypeRef = useRef(tableType);
    const socketStartGameRef = useRef(socketStartGame);
    const volumeRef = useRef(volume);


    useEffect(() => {
        betModeRef.current = betMode;
        socketRef.current = socket;
        socketConnectionRef.current = socketConnection;
        gameStartedRef.current = gameStarted;
        stopAtWinRef.current = stopAtWin;
        betAmountRef.current = betAmount;
        winningBetAmountRef.current = winningBetAmount;
        autoPlayStartRef.current = autoPlayStart;
        minesCountRef.current = minesCount;
        numberOfRoundsRef.current = numberOfRounds;
        autoplayCounterRef.current = autoplayCounter;
        losingBetAmountRef.current = losingBetAmount;
        userDetailsRef.current = userDetails;
        sessionIdRef.current = sessionId;
        muteSoundRef.current = muteSound;
        tableTypeRef.current = tableType;
        socketStartGameRef.current = socketStartGame;
        volumeRef.current = volume;
    }, [betMode,
        socket,
        socketConnection,
        gameStarted,
        stopAtWin,
        betAmount,
        winningBetAmount,
        autoPlayStart,
        minesCount,
        numberOfRounds,
        losingBetAmount,
        userDetails,
        sessionId,
        muteSound,
        tableType,
        socketStartGame,
        volume,
    ]);

    const audioContextRef = useRef(null);
    const audioBuffersRef = useRef({});
  
    useEffect(() => {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      Object.entries(audioFiles).forEach(([key, url]) => {
        fetch(url)
          .then(response => response.arrayBuffer())
          .then(arrayBuffer => audioContextRef.current.decodeAudioData(arrayBuffer))
          .then(decodedAudio => {
            audioBuffersRef.current[key] = decodedAudio; // Store buffer in ref
          })
          .catch(error => console.error(`Error loading ${key}:`, error));
      });
    }, [audioFiles]);
  
    const playMusicForScenario = (key) => {
      if (!audioBuffersRef.current[key]) {
        console.error(`Audio "${key}" not found or not loaded yet.`);
        return;
      }else if(muteSoundRef.current){
        return
      }
  
      const source = audioContextRef.current.createBufferSource();
      const gainNode = audioContextRef.current.createGain();
      
      gainNode.gain.setValueAtTime(volumeRef.current / 100, audioContextRef.current.currentTime);
    
      source.buffer = audioBuffersRef.current[key];
      source.connect(gainNode);
      gainNode.connect(audioContextRef.current.destination);
    
      source.start(0);
    };


    useEffect(() => {
        if (!autoPlayStart) {
            setautoPlayCounter(0)
        }
    }, [autoPlayStart])
    useEffect(() => {
        if (allParams?.token && allParams?.user) {
            setUserToken(allParams?.token)
        } else {
            setSiteLoading(false)
            setUserDetails(null)
        }
    }, [allParams])



    const initializeGameSession = async (isActive) => {
        if (socketRef.current && [WebSocket.CONNECTING, WebSocket.OPEN].includes(socketRef.current.readyState)) return;
        const verification = await verifyToken(userToken, 'mines');
        if (!isActive()) return;

        if (verification.status && verification.data?.userId === allParams.user) {
            setCurrencySymbol(verification.data.currency || 'INR');
            setUserDetails(verification?.data);
            const socketInstance = connectSocket(
                userToken,
                (message) => { if (socketRef.current === socketInstance) handleWebSocketMessage(message); },
                (error) => console.error('WebSocket error:', error),
                (message) => {
                    if (socketRef.current !== socketInstance) return;
                    console.log('WebSocket connection established!', message);
                    subscribeToChannel(socketInstance, 'mines');
                    // MINES_STATE confirms the restored board after the subscription.

                },
                () => {
                    if (socketRef.current !== socketInstance) return;
                    resetStartRequest();
                    resetClaimRequest();
                    socketConnectionRef.current = false;
                    autoPlayStartRef.current = false;
                    setSocketConnection(false);
                    setAutoplayStart(false);
                    setSocketStartGame(false);
                    socketStartGameRef.current = false;
                    setLoadingTile(null);
                    recoveryRef.current?.lost();
                }
            );
            socketInstance.desiManaged = true;
            socketRef.current = socketInstance;
            setSocket(socketInstance);
            setSiteLoading(false);
        } else {
            console.error('Token verification failed:', verification.message);
            setSiteLoading(false);
            setUserDetails(null);
            if (!window.DesiGameError.isBlocked()) recoveryRef.current?.lost();
        }
    };

    useEffect(() => {
        let active = true;
        setAutoplayStart(false)
        if (userToken) {
            recoveryRef.current = window.DesiGameError.createRecovery(
                (isCurrent) => initializeGameSession(() => active && isCurrent()),
                () => socketRef.current?.close()
            );
            recoveryRef.current.start();
        }
        return () => {
            active = false;
            recoveryRef.current?.stop();
            const current = socketRef.current;
            socketRef.current = null;
            if (current) {
                current.onopen = current.onmessage = current.onclose = current.onerror = null;
                current.close();
            }
        };
    }, [userToken]);


    const handleStartGame = (autoStart, updatedBetAmount) => {
        if (startPendingRef.current) return;
        const amount = updatedBetAmount || betAmountRef.current;
        if (!Number.isFinite(Number(amount)) || Number(amount) < gameLimits?.minimumBetAmount) {
            message.error("Bet amount can't be less than " + gameLimits?.minimumBetAmount);
            return;
        }
        if (socketRef.current?.readyState !== WebSocket.OPEN || !socketConnectionRef.current) {
            resetStartRequest();
            setAutoplayStart(false);
            recoveryRef.current?.lost();
            return;
        }
        if (!(betModeRef.current === 'manual' || autoPlayStartRef.current || autoStart)) return;
        startPendingRef.current = true;
        setStartButtonLoading(true);
        const sent = startGame(socketRef.current, {
            userId: userDetailsRef.current?.userId,
            mineCount: minesCountRef.current,
            betAmount: amount,
        });
        if (!sent) { resetStartRequest(); return; }
        startTimerRef.current = setTimeout(() => {
            resetStartRequest();
            setAutoplayStart(false);
            message.warning('Confirmation delayed. Check your game history before trying again.');
        }, 12000);
    };

    const handleRevealBlock = (index, refSessionId) => {
        if (claimTimerRef.current) return;
        let sessionId;
        if (betModeRef.current === "auto") {
            sessionId = refSessionId;
        }
        else {
            sessionId = sessionIdRef.current
        }
        if (socketRef.current && socketConnectionRef.current) {
            revealBlock(socketRef.current, {
                userId: userDetailsRef.current?.userId,
                sessionId: sessionId,
                blockIndex: index,
            });
        }
    };

    const handleClaimGame = () => {
        const currentSocket = socketRef.current;
        const currentSession = sessionIdRef.current;
        if (claimTimerRef.current || !currentSession || currentSocket?.readyState !== WebSocket.OPEN || !socketConnectionRef.current) return;
        setClaimPending(true);
        claimTimerRef.current = setTimeout(() => {
            message.warning("Cash-out confirmation is taking longer than expected. Check My Bets.");
            currentSocket.close();
        }, 20000);
        try {
            claimGame(currentSocket, { userId: userDetailsRef.current?.userId, sessionId: currentSession });
        } catch {
            resetClaimRequest();
            currentSocket.close();
        }
    };

    const handleGetAllBets = () => {
        if (socket) {
            getAllBets(socket, 'mines');
        }
    };

    const getTopBets = () => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            const topBetsMessage = {
                type: "TOP_BETS",
                gameType: "mines"
            };
            socket.send(JSON.stringify(topBetsMessage)); // Send the request
        } else {
            console.log("WebSocket is not connected");
        }
    };

    const getMyBets = () => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            const myBetsMessage = {
                type: "MY_BETS",
                gameType: "mines"
            };
            socket.send(JSON.stringify(myBetsMessage)); // Send the request
        } else {
            console.log("WebSocket is not connected");
        }
    };


    const handleWebSocketMessage = useCallback((message) => {
        console.log("Received WebSocket message:", message);

        if (socketStartGameRef.current && message?.message === "Connection established and authenticated!") {
            handleStartGame();
            setSocketStartGame(false)
        }

        switch (message.type) {
            case "MINES_STATE": {
                resetClaimRequest();
                const active = message.state;
                setSessionId(active?.sessionId || null);
                sessionIdRef.current = active?.sessionId || null;
                setGameStarted(!!active);
                gameStartedRef.current = !!active;
                setOpenedTile(active?.revealedBlocks || []);
                setTiles(Array.from({ length: 25 }, (_, index) => active?.revealedBlocks?.includes(index) ? 0 : ""));
                setWinningAmount(Number(active?.winAmount) || 0);
                if (active) { setBetAmount(active.betAmount); setMinesCount(active.mineCount); }
                setwinningModal(false);
                socketConnectionRef.current = true;
                setSocketConnection(true);
                recoveryRef.current?.ready();
                break;
            }
            case "USER_BALANCE":
                if (isValidWalletBalance(message.userBalance)) setUserBalance(Number(message.userBalance));
                break;

            case "CLAIM_FAILED":
                if (message.sessionId === sessionIdRef.current) {
                    resetClaimRequest();
                    alertMessage.error(message.message);
                }
                break;

            case "CLAIM_ALREADY_RECORDED":
            case "AMOUNT_CLAIMED":
                if (!sessionIdRef.current || (message.sessionId && message.sessionId !== sessionIdRef.current)) break;
                resetClaimRequest();
                sessionIdRef.current = null;
                gameStartedRef.current = false;
                setSessionId(null);
                if (isValidWalletBalance(message.userBalance)) setUserBalance(Number(message.userBalance));
                setTiles(message.board);
                setWinningAmount(message.winAmount);
                setGameStarted(false);
                setwinningModal(true)
                playMusicForScenario("cashout");
                getTopBets();
                getAllBets();

                setTimeout(() => {
                    setOpenedTile([]);
                    setWinningAmount(0);
                    setTiles(Array(25).fill(""));
                    setwinningModal(false)
                    if (betModeRef.current === "auto") {
                        if (stopAtWinRef.current) {
                            setAutoplayStart(false);
                        } else {
                            let newBetAmountWinning = null;
                            if (autoPlayStartRef.current && winningBetAmountRef.current > 0 && autoplayCounterRef.current < numberOfRoundsRef.current - 1) {
                                let newBetAmount = betAmountRef.current * (1 + winningBetAmountRef.current / 100);
                                setBetAmount(newBetAmount)
                                newBetAmountWinning = newBetAmount;

                            }
                            revealRandomBlock(newBetAmountWinning);
                        }
                    }

                }, 2500);
                break;

            case "GAME_OVER":
                resetClaimRequest();
                setStartButtonLoading(false)
                if (isValidWalletBalance(message.userBalance)) setUserBalance(Number(message.userBalance));
                setTiles(message.board);
                setWinningAmount(message.winAmount);
                setGameStarted(false);
                setLoadingTile(null)
                playMusicForScenario("bomb");
                getMyBets()
                getTopBets()
                getAllBets()

                setTimeout(() => {
                    setOpenedTile([]);
                    setWinningAmount(0);
                    setTiles(Array(25).fill(""));
                    if (betModeRef.current === "auto") {

                        if (autoPlayStartRef.current && losingBetAmountRef.current > 0 && autoplayCounterRef.current < numberOfRoundsRef.current - 1) {
                            let newBetAmount = betAmountRef.current * (1 + losingBetAmountRef.current / 100);

                            setBetAmount(newBetAmount)
                        }
                        revealRandomBlock();
                    }
                }, 2500);
                break;


            case "BLOCK_REVEALED":
                setLoadingTile(null);

                if (parseFloat(message?.winAmount) > 0) {
                    playMusicForScenario("dimond1");
                } else {
                    playMusicForScenario("bomb");
                }
                setTiles((prevTiles) => {
                    const newTiles = [...prevTiles];
                    newTiles[message?.blockIndex] = parseFloat(message?.winAmount) > 0 ? 0 : 1;
                    return newTiles;
                });
                setOpenedTile((prevOpenedTiles) => [...prevOpenedTiles, message?.blockIndex]);
                setWinningAmount(parseFloat(message?.winAmount))
                if (betModeRef.current === "auto") {
                    handleClaimGame()
                }
                break;


            case "TOP_BETS":
                if (tableTypeRef.current === "top") {
                    setTableData(message.topBets)
                }
                setTopBetData(message.topBets);
                setTableLoading(false)
                break;
            case "MY_BETS":
                const sortedData = message.myBets.sort((a, b) => {
                    const dateA = moment(a.createdAt);
                    const dateB = moment(b.createdAt);
                    return dateB.isBefore(dateA) ? -1 : 1;
                });
                if (tableTypeRef.current === "my") {
                    setTableData(sortedData)
                }
                setMyBetData(sortedData);
                setTableLoading(false)
                break;
            case "ALL_BETS":
                if (tableTypeRef.current === "all") {
                    setTableData(message.allBets)
                }
                setAllBetData(message.allBets)
                setTableLoading(false);
                break;
            case "GAME_STARTED":
                resetStartRequest();
                sessionIdRef.current = message.sessionId;
                gameStartedRef.current = true;
                setSessionId(message?.sessionId)
                if (isValidWalletBalance(message?.userBalance)) setUserBalance(Number(message?.userBalance))
                setGameStarted(() => true);
                setOpenedTile([]);
                setWinningAmount(0);
                setTiles(Array(25).fill(""));
                setwinningModal(false)
                if (betModeRef.current === "auto") {
                    const blockIndex = Math.floor(Math.random() * 25);
                    setAutoplayStart(true)
                    tileClick(blockIndex, message?.sessionId);
                }
                setStartButtonLoading(false);

                break;
            case "GAME_ENDED":
                setGameStarted(false);
                break;
            case "BETS":
                getMyBets()
                if (tableTypeRef.current === "all") {
                    setAllBetData(prev => ([message?.newBet, ...prev]))
                    setTableData(prev => ([message?.newBet, ...prev]))
                } else {
                    let allTopBets = [...topBetData, message?.newBet];
                    const sortedData = allTopBets.sort((a, b) => {
                        const priceA = a.winAmount;
                        const priceB = b.winAmount;
                        return priceB - priceA;
                    });
                    setTopBetData(sortedData);
                }
                break;
            case "ERROR":
                resetStartRequest();
                setLoadingTile(null);
                console.error("Error:", message.message);
                if (!gameStartedRef.current) setGameStarted(false);
                setAutoplayStart(false);
                setStartButtonLoading(false)
                alertMessage.destroy();
                break;
            case "ALL_MULTIPLIERS":
                setAllMultiplier(message?.multipliers)
                break;
            case "GAME_LIMITS":
                setGameLimits(message?.gameLimits);
                if(betAmountRef.current<message?.gameLimits?.minimumBetAmount){
                    setBetAmount(message?.gameLimits?.minimumBetAmount);
                }
                break;
            default:
                console.log(`Unknown message type: ${message.type} ${message}`);
        }
    }, [betMode, gameStarted, userBalance, sessionId]);


    const getCurrencySymbol = (currencyCode) => {
        const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currencyCode
        });
        const formatted = formatter.format(1);
        return formatted.replace(/[0-9,.]/g, '').trim();
    };

    const revealRandomBlock = async (newBetAmountWinning) => {
        if (autoPlayStartRef.current && (autoplayCounterRef.current < numberOfRoundsRef.current - 1 || numberOfRoundsRef.current === 0)) {
            setautoPlayCounter(prev => prev + 1)
            if (newBetAmountWinning) {
                handleStartGame(true, newBetAmountWinning)
            }
            else {
                handleStartGame()
            }
        } else {
            setAutoplayStart(false);
            setautoPlayCounter(0);
        }
    }
    const tileClick = async (index, refSessionId) => {

        if (loadingTile || openedTiles.includes(index)) {
            return;
        }
        if (!gameStartedRef.current && betModeRef.current !== "auto") {
            alertMessage.destroy();
            alertMessage.warning("Start game first!");
            return;
        }

        if (betModeRef !== "auto") {
            playMusicForScenario("tile");
        }

        setLoadingTile(index);
        handleRevealBlock(index, refSessionId)

    };

    const _changeRounds = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9]/g, '');
        if (value.length > 3) {
            value = value.slice(0, 3);
        }
        if (parseInt(value) > 0 && parseInt(value) < 1000) {
            setNumberOfRounds(parseInt(value));
        } else {
            setNumberOfRounds(0)
        }
    }
    const _changeTable = (type) => {

        playMusicForScenario("buttons");
        setTableType(type)

        if (type === "all") {
            handleGetAllBets();
            setTableLoading(true);
            setTableData(allBetData);
        }
        else if (type === "my") {
            getMyBets();
            setTableLoading(true);
            setTableData(myBetData)
        }
        else if (type === "top") {
            getTopBets();
            setTableLoading(true);
            setTableData(topBetData)
        }

    }

    useEffect(() => {
        if (betAmount && minesCount) {
            if(minesCount>2){
                setmultiplier(Allmultipliers?.[`${minesCount}`]);
            }
        }
    }, [betAmount, minesCount,Allmultipliers])

    const _changeBetAmount = (e) => {
        let value = e.target.value;
        let min = gameLimits?.minimumBetAmount||10;
        let max = gameLimits?.maximumBetAmount||1000;
        value = value.replace(/[^0-9]/g, '');
        if (value.length > 5) {
            value = value.slice(0, 3);
        }
        if(isNaN(value)){
            setBetAmount("")
        }else{
            setBetAmount(parseInt(value));
        }
        
    }
    const _changeWwAmount = (number) => {
        if (isNaN(parseInt(number))) {
            setWinningBetAmount("")
        }
        else if (number >= 0 && number <= 999) {
            setWinningBetAmount(number)
        }
    }
    const _changeWLAmount = (number) => {
        if (isNaN(parseInt(number))) {
            setLosingBetAmount("")
        }
        else if (number >= 0 && number <= 999) {
            setLosingBetAmount(number)
        }
    }
    const _changeMinesCount = (number) => {
        playMusicForScenario("difficulty")
        if (isNaN(parseInt(number))) {
            setMinesCount(2)
        }
        else if (number >= 2 && number <= 24) {
            setMinesCount(number)
        }
    }
    const _startGame = () => {

        if (claimTimerRef.current) return;
        setLoadingTile(null)
        if (betModeRef.current === "auto") {
            if (autoPlayStart) {
                setAutoplayStart(false);
            } else if (socket) {
                handleStartGame(true);
            }
        }
        else {
            if (gameStartedRef.current) {
                handleClaimGame();
            } else {
                playMusicForScenario("roll");
                handleStartGame();
            }
        }
    }

    const _setBetAmount = (amount) => {
        if(amount>=(gameLimits?.minimumBetAmount||1) && amount<=(gameLimits?.maximumBetAmount || 1000)){
            playMusicForScenario("amount")
            setBetAmount(amount)
        }
    }

    const formatNumber = (number) => {
        if (Number.isInteger(number)) {
            return number;
        } else if (number?.length > 0 || number > 0) {
            return number.toFixed(2)
        }
        return "";
    };

    return (

        userDetails ?
            <div className="minesPage">
                <div className="minesHeader">
                    <div className="wrapper">
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <div className="d-flex align-items-center gap-3 mhLeft">
                                <Link to={allParams?.return_url}>
                                    <img
                                        src="/assets/images/leftArrowCircle.svg"
                                        alt=""
                                        className="mhLeftArrow"
                                    />
                                </Link>
                                <div className="mines-title-brand">
                                <Link>
                                    <img
                                        src="/assets/images/minesLogo.png"
                                        alt=""
                                        className="mhLogo"
                                    />
                                </Link>
                                <ProviderCredit header />
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-3 mhRight">
                                <div className="d-flex align-items-center gap-2">
                                    <p className="mhBalanceText text-white d-none d-md-block">Balance:</p>
                                    <div className="mhBalanceOuter">
                                        <div className="d-flex align-items-center gap-2">
                                            {/* <img
                                src="/assets/images/dollersign.png"
                                alt=""
                                className="mhDoller"
                            /> */}
                                            <span className={`mhDoller ${currencySymbol?.length > 1 ? "smallCurrency" : ""}`}>
                                                {currencySymbol || "$"}
                                            </span>
                                            <p className="mhBalanceText text-white">{parseFloat(userBalance).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    className={`soundIcon ${muteSound ? "active" : ""}`}
                                    onClick={() => setMuteSound((prev) => !prev)}
                                >
                                    <img src="/assets/images/soundIcon.png" alt="" style={{ width: "100%" }} />
                                </button>
                                <button onClick={() => setSettingsVisible(true)}>
                                    <img src="/assets/images/settingsIcon.png" alt="" style={{ width: "100%" }} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="playGameSec">
                    <div className="wrapper">
                        <div className="playGameSecInner d-flex">
                            <div className="pgsLeft">
                                <div className={`pgsTopButtons d-flex justify-content-between align-items-center ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>

                                    <button
                                        className={`defaultButton ${betMode === "manual" ? "active" : ""}`}
                                        onClick={() => { playMusicForScenario("buttons"); setBetMode("manual"); setAutoplayStart(false) }}
                                    >
                                        Manual <span className="buttonLight"></span>
                                    </button>
                                    <button
                                        className={`defaultButton ${betMode === "auto" ? "active" : ""}`}
                                        onClick={() => { playMusicForScenario("buttons"); setBetMode("auto") }}
                                    >
                                        Auto <span className="buttonLight"></span>
                                    </button>
                                </div>
                                <div className={`betAmountSec ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                    <p>Bet Amount</p>
                                    <div className="basAmount">
                                        <span className={`mhDoller ${currencySymbol?.length > 1 ? "smallCurrency" : ""}`}>
                                            {currencySymbol || "$"}
                                        </span>
                                        <input type="number" value={formatNumber(betAmount)} onChange={_changeBetAmount} maxLength={5} min={gameLimits?.minimumBetAmount||1} />
                                    </div>
                                </div>
                                <div className={`amountControler d-flex justify-content-between align-items-center ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                    <button className="defaultButton" onClick={() => _setBetAmount(gameLimits?.minimumBetAmount || 1)}>Min</button>
                                    <button
                                        className="defaultButton"
                                        onClick={() => _setBetAmount(betAmount - 2)}
                                    >-</button>
                                    <button
                                        className="defaultButton"
                                        onClick={() => _setBetAmount(betAmount + 2)}
                                    >+</button>
                                    <button className="defaultButton" onClick={() => _setBetAmount(gameLimits?.maximumBetAmount || 1000)}>Max</button>
                                </div>
                                <div className={`minesControler mobileAmountController ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                    <button className="defaultButton"
                                        onClick={() => _setBetAmount(gameLimits?.minimumBetAmount || 1)}
                                    >
                                        Min</button>
                                    <button
                                        className="defaultButton"
                                        onClick={() => _setBetAmount(betAmount - 2 )}
                                        disabled={betAmount < 2}
                                    >-</button>
                                    <div className="adjustMinesOuter">
                                        <div className="adjustMines">
                                            <div className="minesCount">
                                                <span>Bet Amount</span>
                                                <div className="basAmount">
                                                    <span className={`mhDoller ${currencySymbol?.length > 1 ? "smallCurrency" : ""}`}>
                                                        {currencySymbol || "$"}
                                                    </span>
                                                    <input type="number" value={formatNumber(betAmount)} min={gameLimits?.minimumBetAmount || 1} onChange={_changeBetAmount} maxLength={5} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        className="defaultButton"
                                        onClick={() => _setBetAmount(betAmount + 2)}
                                    >+</button>
                                    <button
                                        className="defaultButton"
                                        onClick={() => _setBetAmount(gameLimits?.maximumBetAmount || 1000)}
                                    >Max</button>
                                </div>
                                <div className={`minesControler  ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                    <button className="defaultButton" onClick={() => _changeMinesCount(3)}>3</button>
                                    <button className="defaultButton" onClick={() => _changeMinesCount(5)}>5</button>
                                    <div className="adjustMinesOuter">
                                        <div className="adjustMines">
                                            <button onClick={() => _changeMinesCount(parseInt(minesCount - 1))}>-</button>
                                            <div className="minesCount">
                                                <span>Mines</span>
                                                <input
                                                    type="number"
                                                    value={minesCount}
                                                    onChange={(e) => _changeMinesCount(e.target.value)}
                                                    maxLength={3}
                                                />
                                            </div>
                                            <button onClick={() => _changeMinesCount(parseInt(minesCount + 1))}>+</button>
                                        </div>
                                    </div>
                                    <button className="defaultButton" onClick={() => _changeMinesCount(10)}>10</button>
                                    <button className="defaultButton" onClick={() => _changeMinesCount(20)}>20</button>
                                </div>
                                {
                                    betMode === "auto" ?
                                        <div className={`autobet ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                            <div className="betAmountSec numberOfRounders">
                                                <div className="basLeft">
                                                    <p>No of rounds</p>
                                                    <div className="basAmount">
                                                        <input type="number" value={numberOfRounds} onChange={_changeRounds} min={0} maxLength={3} />
                                                    </div>
                                                </div>
                                                <div className="basRight">
                                                    {
                                                        numberOfRounds < 1 ?
                                                            <img src="/assets/images/infinity-svgrepo-com.svg" alt="" width={22} />
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                            <div className="whenWinning">
                                                <span>When Winning</span>
                                                <div className="percentButtons">
                                                    <button
                                                        className={`defaultButton ${whenWinningtt === "reset" ? "active" : ""}`}
                                                        onClick={(e) => { playMusicForScenario("buttons"); setWhenWinningtt("reset"); }}
                                                    >
                                                        Reset
                                                    </button>
                                                    <button
                                                        className={`defaultButton ${whenWinningtt === "increase" ? "active" : ""}`}
                                                        onClick={(e) => { playMusicForScenario("buttons"); setWhenWinningtt("increase") }}
                                                    >
                                                        Increase by
                                                    </button>
                                                    <input
                                                        type="number"
                                                        value={whenWinningtt === "increase" ? winningBetAmount : 0}
                                                        onChange={(e) => _changeWwAmount(e.target.value)}
                                                        maxLength={3}
                                                        disabled={whenWinningtt === "reset"}
                                                    />
                                                    <span>%</span>
                                                </div>
                                            </div>
                                            <div className="whenWinning whenLosing">
                                                <span>When Losing</span>
                                                <div className="percentButtons">
                                                    <button
                                                        className={`defaultButton ${whenLosingtt === "reset" ? "active" : ""}`}
                                                        onClick={(e) => { playMusicForScenario("buttons"); setWhenLosingtt("reset"); }}
                                                    >
                                                        Reset
                                                    </button>
                                                    <button
                                                        className={`defaultButton ${whenLosingtt === "increase" ? "active" : ""}`}
                                                        onClick={(e) => { playMusicForScenario("buttons"); setWhenLosingtt("increase") }}
                                                    >
                                                        Increase by
                                                    </button>
                                                    <input type="number"
                                                        disabled={whenLosingtt === "reset"}
                                                        value={whenLosingtt === "increase" ? losingBetAmount : 0}
                                                        onChange={(e) => _changeWLAmount(e.target.value)}
                                                        maxLength={3}
                                                    />
                                                    <span>%</span>
                                                </div>
                                            </div>
                                            <div className="whenWinning stopAtWin">
                                                <span>Stop at any win</span>
                                                <div className="sawToggle">
                                                    <Switch
                                                        onChange={(e) => { playMusicForScenario("buttons"); setStopAtWin(e) }}
                                                        value={stopAtWin}
                                                        size="default"
                                                        style={{
                                                            backgroundColor: '#00BFFF33',
                                                            borderColor: '#00BFFF33',
                                                        }}
                                                    />
                                                    <span className={`toggleDot ${stopAtWin ? "active" : ""}`}></span>
                                                </div>

                                            </div>
                                        </div>
                                        : null
                                }
                                <div className={`playGame ${gameStarted || autoPlayStart ? "gameStarted" : ""}`}>
                                    <Button loading={claimPending || (startButtonLoading && !autoPlayStart)} onClick={_startGame} disabled={claimPending || (winningModal && !autoPlayStart)||(gameStarted && betMode !== "auto"&&number<=0)}>
                                        {
                                            gameStarted || autoPlayStart ? null :
                                                <img src="/assets/images/pauseButton.svg" alt="" />
                                        }
                                        {
                                            (betMode === "auto" && !autoPlayStart) ?
                                                "Start Autoplay"
                                                :
                                                (betMode === "auto" && autoPlayStart) ?
                                                    "Stop Autoplay"
                                                    :
                                                    (gameStarted && betMode !== "auto") ?
                                                        <>
                                                        {
                                                            number>0?
                                                            <>
                                                            Cashout {currencySymbol + " "}
                                                            <CountUp
                                                                key={number}
                                                                start={oldNumber}
                                                                end={number}
                                                                duration={2}
                                                                decimals={2}
                                                                separator=","
                                                            />
                                                            </>

                                                            :"Game Started"
                                                        }
                                                        </>

                                                        : "Start Game"

                                        }
                                    </Button>
                                </div>
                                {
                                    betMode === "manual" ?
                                        <div className="gameDetailsOuter">
                                            <div className="gameDetails">
                                                <h5>Game Details</h5>
                                                <div className="gdTable">
                                                    <div className="gdtRow">
                                                        <div className="gdtLeft">
                                                            <img src="/assets/images/dimondIcon.png" alt="" />
                                                            <span>Gems Left</span>
                                                        </div>
                                                        <div className="gdtRight">
                                                            {25 - minesCount}
                                                        </div>
                                                    </div>
                                                    <div className="gdtRow">
                                                        <div className="gdtLeft">
                                                            <img src="/assets/images/potIcon.png" alt="" />
                                                            <span>Mine risk</span>
                                                        </div>
                                                        <div className="gdtRight">
                                                            {parseInt((minesCount / 25 * 100)).toFixed(2)}%
                                                        </div>
                                                    </div>
                                                    <div className="gdtRow">
                                                        <div className="gdtLeft">
                                                            <img src="/assets/images/windowLogo.png" alt="" />
                                                            <span>Opened tiles</span>
                                                        </div>
                                                        <div className="gdtRight">
                                                            {openedTiles?.length}/25
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        : null
                                }

                            </div>
                            <div className="pgsRight">
                                <div className="betLevels">
                                    {
                                        multiplier?.length > 0 ?
                                            multiplier?.map((mlt) => (
                                                <span key={mlt} className=
                                                    {
                                                        openedTiles?.length>0 && mlt<=multiplier[openedTiles?.length-1] ? "active" : ""
                                                    }>
                                                    x{mlt}
                                                </span>
                                            ))
                                            : null
                                    }

                                </div>
                                <div className={`pgsTopButtons d-flex justify-content-between align-items-center ${gameStarted || autoPlayStart ? "disabledSec" : ""}`}>
                                    <button
                                        className={`defaultButton ${betMode === "manual" ? "active" : ""}`}
                                        onClick={() => { playMusicForScenario("buttons"); setBetMode("manual") }}
                                    >
                                        Manual <span className="buttonLight"></span>
                                    </button>
                                    <button
                                        className={`defaultButton ${betMode === "auto" ? "active" : ""}`}
                                        onClick={() => { playMusicForScenario("buttons"); setBetMode("auto") }}
                                    >
                                        Auto <span className="buttonLight"></span>
                                    </button>
                                </div>
                                <div className="mineTilesContainer" style={{ position: "relative" }}>
                                    {tiles.map((value, index) => (
                                        <div
                                            key={index}
                                            className={`mineTile ${value !== "" ? 'revealed' : ''}`}
                                            onClick={() => { betMode === "manual" && tileClick(index) }}
                                        >
                                            {value !== "" ? (
                                                <div className="mineInnerOuter">
                                                    <div className="mineInner">
                                                        {
                                                            value ?
                                                                <img src="/assets/images/BOMB.svg" alt="" />
                                                                :
                                                                <img src="/assets/images/diamond.svg" alt="" />
                                                        }
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="mineTileOverlay">
                                                    {!(gameStarted || autoPlayStart) ? "?" : ""}
                                                    {
                                                        loadingTile === index ?
                                                            <span className="loadingTile">
                                                                <img src="/assets/images/puff.6bba35fd.svg" alt="" />
                                                            </span>
                                                            :

                                                            gameStarted && !autoPlayStart ?
                                                                <div className="tileOverlayHover">
                                                                    {currencySymbol} {parseFloat(multiplier[openedTiles?.length]*betAmount).toFixed(2)}
                                                                </div>
                                                                : null
                                                    }
                                                </div>
                                            )}

                                        </div>
                                    ))}


                                    {
                                        winningModal ?
                                            <div className="winningModal">
                                                <div className="winnerModalInner">
                                                    <div className="wmHeader">
                                                        You win!
                                                    </div>
                                                    <h5>{currencySymbol}{" "}{winningAmount}</h5>
                                                    <div className="wmBottom">
                                                        <span>Multiplier</span>
                                                        <big>x{multiplier[openedTiles.length-1]}</big>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrapper">
                    <hr style={{ background: "#294898", height: "2px", width: "96.3%", marginBottom: 40 }} />
                </div>
                <div className="gameRecordsSec">
                    <div className="wrapper">
                        <div className="grInner">
                            <div className="grButttons">
                                <button className={`defaultButton ${tableType === "all" ? "active" : ""}`} onClick={() => _changeTable("all")}>All Bets</button>
                                <button className={`defaultButton ${tableType === "top" ? "active" : ""}`} onClick={() => _changeTable("top")}>Top Bets</button>
                                <button className={`defaultButton ${tableType === "my" ? "active" : ""}`} onClick={() => _changeTable("my")}>My Bets</button>
                            </div>
                            <AutoScrollTable tableData={tableData} tableLoading={tableLoading} currencySymbol={currencySymbol} />
                        </div>
                    </div>
                </div>
                <footer className="wrapper">
                    <div className="provider-credit-row"><ProviderCredit /></div>
                </footer>
                {
                    settingsModalVisible ?
                        <SettingsModal
                            settingsModalVisible={settingsModalVisible}
                            setSettingsVisible={setSettingsVisible}
                            setLimitModalVisible={setLimitModalVisible}
                            setRulesModalVisible={setRulesModalVisible}
                            volume={volume}
                            setVolume={setVolume}
                            userDetails={userDetails}
                        />
                        : null

                }
                {
                    limitModalVisible ?
                        <LimitsModal limitModalVisible={limitModalVisible} setLimitModalVisible={setLimitModalVisible} gameLimits={gameLimits} currencySymbol={currencySymbol} />
                        : null
                }
                {
                    rulesModalVisible ?
                        <RulesModal rulesModalVisible={rulesModalVisible} setRulesModalVisible={setRulesModalVisible} />
                        : null
                }
                {
                    siteLoading ? <LoadingSlide /> : null
                }
            </div>
            :
            null

    );
}

const AutoScrollTable = ({ tableData, tableLoading, currencySymbol }) => {

    const [isMobile, setIsMobile] = useState(false);

    const updateScreenSize = () => {
        setIsMobile(window.innerWidth <= 993);
    };
    useEffect(() => {
        updateScreenSize();
        window.addEventListener('resize', updateScreenSize);

        return () => {
            window.removeEventListener('resize', updateScreenSize);
        };
    }, []);


    const columns = isMobile ? [
        {
            title: 'Player',
            dataIndex: 'userName',
            key: 'userName',
            // width:120
        },
        {
            title: 'Multiplier',
            dataIndex: 'multiplier',
            key: 'multiplier',
            // width:100,
            render: (d, record) => d >= 0 ? parseFloat(d).toFixed(2) + "x" : "0.00x"
        },
        {
            title: 'Payout',
            dataIndex: 'winAmount',
            key: 'winAmount',
            render: (d) => currencySymbol + " " + parseFloat(d).toFixed(2)
        },
    ] : [
        {
            title: 'Game',
            key: 'game',
            render: () => "Mines",
            // width:90
        },
        {
            title: 'Player',
            dataIndex: 'userName',
            key: 'userName',
            // width:150,
        },
        {
            title: 'Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (d) => moment(d).format("HH:mm A"),
            // width:100
        },
        {
            title: 'Bet Amount',
            dataIndex: 'betAmount',
            key: 'betAmount',
            render: (d) => currencySymbol + " " + parseFloat(d).toFixed(2),
            // width:150
        },
        {
            title: 'Multiplier',
            dataIndex: 'multiplier',
            key: 'multiplier',
            render: (d, record) => d >= 0 ? parseFloat(d).toFixed(2) + "x" : parseFloat(d).toFixed(2),
            width:120
        },
        {
            title: 'Payout',
            dataIndex: 'winAmount',
            key: 'winAmount',
            render: (d) => currencySymbol + " " + parseFloat(d).toFixed(2),
            // width:150
        },
    ];

    return (
        <div style={{ paddingBottom: 20 }} className="autoScrollTable">
            <Table
                dataSource={tableData}
                columns={columns}
                pagination={false}
                height={568}
                scroll={{ y: 568, x: 'max-content' }}
                rowClassName="custom-row"
            // loading={tableLoading}
            />
        </div>
    );
};

const RowDataModal = ({ rowdata, rowModalVisible, setRowModalVisible }) => {
    return (
        <Modal open={rowModalVisible} onCancel={() => setRowModalVisible(false)} footer={null} >
            <div className="modalHeader">
                <button>
                    <img src="/assets/images/cross-small-svgrepo-com.svg" alt="" />
                </button>
            </div>
        </Modal>
    )
}

const SettingsModal = ({
    settingsModalVisible,
    setSettingsVisible,
    setLimitModalVisible,
    setRulesModalVisible,
    volume,
    setVolume,
    userDetails
}) => {
    const nicknameLength = 32;
    const [nickName, setNickName] = useState(userDetails?.userName)
    const [NickNameEdit, setNickNameEdit] = useState(false);

    const _changeNickName = (e) => {
        let value = e.target.value;
        if (value?.length <= nicknameLength) {
            setNickName(e.target.value)
        }
    }

    return (
        <Modal
            open={settingsModalVisible}
            onCancel={() => { setSettingsVisible(false) }}
            width={280}
            className="settingModal"
            footer={null}
        >
            <div className="settingsHeader">
                <span>Settings</span>
                <span onClick={() => setSettingsVisible(false)}>
                    <img src="/assets/images/cross-small-svgrepo-com-dark.svg" alt="" width={12} />
                </span>
            </div>
            <div className="settingsNickname">
                <div className="snLabel">
                    <span>NickName</span>
                    {/* {
                        NickNameEdit ?
                        <p>{nickName?.length}/{nicknameLength}</p>
                        :null

                    } */}
                </div>
                <div className="snInput">
                    <input type="text" readOnly value={nickName} />
                    {
                        NickNameEdit ?
                            <img src="/assets/images/edit-2-svgrepo-com.svg" alt="" width={15} />
                            : null
                    }
                </div>
            </div>
            <div className="snButtons">
                <button onClick={() => { setLimitModalVisible(true); setSettingsVisible(false) }}>
                    <span className="snLeft">
                        <span className="circleIcon"></span>
                    </span>
                    <div className="snRight">
                        <span>Limits</span>
                    </div>
                </button>
                <button onClick={() => { setRulesModalVisible(true); setSettingsVisible(false) }}>
                    <span className="snLeft">
                        <img src="/assets/images/document-svgrepo-com.svg" alt="" width={15} />
                    </span>
                    <div className="snRight">
                        <span>Rules</span>
                    </div>
                </button>
            </div>
            <div className="snSound">
                <img src="/assets/images/sound-loud-filled-svgrepo-com.svg" alt="" width={25} />
                <Slider
                    value={volume}
                    onChange={(vol) => setVolume(vol)}
                    min={0}
                    max={100}
                    step={1}
                />
            </div>

        </Modal>
    )
}
const LimitsModal = ({ limitModalVisible, setLimitModalVisible,gameLimits,currencySymbol}) => {

    return (
        <Modal
            open={limitModalVisible}
            onCancel={() => setLimitModalVisible(false)}
            width={280}
            className="settingModal limitsModal"
            footer={null}
        >
            <div className="settingsHeader">
                <span>Limits</span>
                <span onClick={() => setLimitModalVisible(false)}>
                    <img src="/assets/images/cross-small-svgrepo-com-dark.svg" alt="" width={12} />
                </span>
            </div>
            <div className="settingsNickname">
                <div className="snLabel">
                    <span>Min bet</span>
                </div>
                <div className="snInput">
                    <p>{currencySymbol}{" "}{gameLimits?.minimumBetAmount}</p>
                </div>
            </div>
            <div className="settingsNickname">
                <div className="snLabel">
                    <span>Max bet</span>
                </div>
                <div className="snInput">
                       <p>{currencySymbol}{" "}{gameLimits?.maximumBetAmount}</p>
                </div>
            </div>
            <div className="settingsNickname" style={{ marginBottom: 0 }}>
                <div className="snLabel">
                    <span>Max Profit</span>
                </div>
                <div className="snInput">
                    <p>{currencySymbol}{" "}{gameLimits?.maximumWinAmount}</p>
                </div>
            </div>

        </Modal>
    )
}
const RulesModal = ({ rulesModalVisible, setRulesModalVisible }) => {

    return (
        <Modal
            open={rulesModalVisible}
            onCancel={() => setRulesModalVisible(false)}
            width={280}
            className="settingModal rulesModal"
            footer={null}
        >
            <div className="settingsHeader">
                <span>Rules</span>
                <span onClick={() => setRulesModalVisible(false)}>
                    <img src="/assets/images/cross-small-svgrepo-com-dark.svg" alt="" width={12} />
                </span>
            </div>
            <div className="rulesDescription">
                Turn on your sixth sense and find all the gems without hitting a mine! 💣
            </div>
            <div className="ruleBook">
                <Collapse accordion className="custom-collapse">
                    <Panel header="How to Play?" key="1" className="custom-panel">
                        <ul>
                            <li>Choose the number of mines and press "Start Game" to begin</li>
                            <li>Look for the gems but beware of mines!</li>
                            <li>Cash Out before you hit a mine and a reward is yours!</li>
                        </ul>
                    </Panel>
                    <Panel header="Game Details" key="2" className="custom-panel">

                        <h3>Place Bet</h3>

                        <p>Enter a valid amount in the field “Amount”.<br />
                            Choose the number of mines from 2 to 24. The more mines are on the playing field, the higher the winning multiplier will be, as well as&nbsp;blow up chance.<br />
                            Press “Start Game”</p>

                        <h3>Gameplay</h3>

                        <p>Open tiles looking for gems. With each opened gem payout multiplier&nbsp;increases.<br />
                            But if you hit a mine you lose your bet. So choose wisely!<br />
                            Use the "Game details" table to evaluate your chances.</p>

                        <h3>Cash Out</h3>

                        <p>When you've found one or more gems - you can press "Cash Out" to collect your reward.<br />
                            Win amount = current payout multiplier * bet amount.<br />
                            Win amount is rounded down to two decimal places.<br />
                            If you've found all gems - Cash Out will be triggered automatically.</p>

                        <h3>Min &amp; Max Multiplier</h3>

                        <p>The minimum win&nbsp;multiplier&nbsp;is&nbsp;х1.03.<br />
                            The maximum win&nbsp;multiplier&nbsp;is&nbsp;х4940285 (it could be achieved for setting with 13 mines &amp; 12&nbsp;successively opened tiles).&nbsp;However, the maximum win is limited by the operator and can be accessed from the “Limits” section in the settings menu.</p>

                        <h3>Cancel</h3>

                        <p>You can cancel the bet only if you haven't opened any&nbsp;tiles yet.</p>

                        <h3>Mine risk calculation formula</h3>

                        <p>Mine risk = Mines Quantity / (All Tiles - Opened Tiles) * 100%</p>

                        <h3>RTP</h3>

                        <p>Game relies on a coefficient called "RTP" (Return to Player) which is the statistical average of payouts over billions of rounds.<br />
                            Mines has a minimum RTP of 94.40%. The maximum RTP of 95.30% can be achieved by cashing out at a multiplier of x1.03.</p>
                    </Panel>
                    <Panel header="Autoplay" key="3" className="custom-panel">
                        <p>You can switch to the Auto mode and configure the bet settings so the system will play instead of you.</p>
                        <p>Settings:</p>
                        <ul>
                            <li>choose tiles to be opened on the playfield</li>
                            <li>number of mines</li>
                            <li>bet amount. This sum will be applied for every auto game</li>
                            <li>number of rounds. If the field is left blank, the game will run until you press the stop button.</li>
                            <li>actions on win/loss. You can increase your bet sum by N% or reset in to default value, which you've set in the "Amount" field</li>
                            <li>"stop at any win" toggle will stop autoplay on win, even if number of rounds in the queue &gt; 0</li>
                        </ul>
                        <p>You can stop autobetting by clicking on "Stop Autoplay" button.</p>
                    </Panel>
                    <Panel header="Bets History" key="5" className="custom-panel">
                        <p>At the bottom of each Turbo game there is a panel with information about:</p>
                        <ul>
                            <li>“All bets” - recently played games across all users</li>
                            <li>“Top bets” - recent winning bets with multiplier above x10</li>
                            <li>“My bets” - list of your recent bets</li>
                        </ul>
                        <p>You can click on any bet to see the details.</p>
                    </Panel>
                    <Panel header="Disconnection Policy" key="6" className="custom-panel">
                        <p>We prioritize the security and satisfaction of our players, even in the event of unexpected internet connection interruptions. Here's how we handle such situations:</p>
                        <ul>
                            <li>If a bet is placed after a disconnection, it will not be sent to the server, no funds will be deducted, and the game will not proceed.</li>
                            <li>If a disconnection occurs during an active game, the game state on the server will remain unchanged. Players will be able to resume the game once the connection is restored.</li>
                        </ul>
                    </Panel>

                </Collapse>
            </div>

        </Modal>
    )
}

const LoadingSlide = () => {
    return (
        <div className="loadingScreen">
            <div>
                <img src="/assets/images/logo.png" alt="" width={150} style={{ margin: "0 auto" }} />
                <p style={{ margin: "15px auto", textAlign: "center", color: "white", fontSize: 18, fontWeight: 500 }}>Loading..</p>
            </div>
        </div>
    )
}
